/* eslint-disable react/prop-types */

import PropTypes from 'prop-types';
import { AiFillCaretRight } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardSubtitle, CardText, CardTitle } from 'reactstrap';

export default function TrustCard({ size, title, subtitle, to }) {
  return (
    <Card className={`card-field ${size}`}>
      <CardBody>
        <CardTitle className="card-title">{title}</CardTitle>
        <CardSubtitle className="card-subtitle">{subtitle}</CardSubtitle>
        <div className="card-text">
          <CardText>
            <Link className="card-link" to={to}>
              View
            </Link>
            <AiFillCaretRight />
          </CardText>
        </div>
      </CardBody>
    </Card>
  );
}

TrustCard.prototype = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'default']),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  to: PropTypes.string.isRequired,
};
TrustCard.defaultProps = {
  size: 'sm',
  color: 'primary',
  subtitle: '',
  title: '',
};
